import React from "react";
import SkeletonElement from "./SkeletonElement";

export default function SkeletonCardDocument() {
  return (
    <div className="p-5 space-y-5 skeletonWrapper rounded-2xl animate-pulse">
      <SkeletonElement type="title" />
      <SkeletonElement type="text" />
    </div>
  );
}
